<script>
    export default {
        name: "VuePaginationHelper",
        data() {
            return {
                pagingLoading: false,
            };
        },
        computed: {
            /**
             * fetch 메서드가 존재하면 페이지네이션이 가능합니다.
             */
            canPagination() {
                return !!this.fetch && !!this.fetchCount && !this.canInfinitePagination;
            },
        },
        methods: {
            goPaging(ipage) {
                console.log("jjw goPaging");
                return new Promise((resolve, reject) => {
                    this.pagingLoading = true;
                    Promise.resolve(this.fetch(ipage, this.itemsPerPage, this.innerSortByComputed, this.innerSortDesc))
                        .then((items) => {
                            this.pagingLoading = false;
                            this.list = this.wrap(items);
                            this.$nextTick(() => {
                                this.scrollToTop();
                            });
                            resolve();
                        })
                        .catch(e => { // 데이터 로드중 에러가 발생하면 error 처리합니다.
                            reject(e);
                        });
                });
            },

            initPagination() {
                this.pagingLoading = true;
                Promise.resolve(this.fetchCount())
                    .then(async count => {
                        this.pagingLoading = false;
                        if (typeof count === 'string') {
                            this.totalCount = parseInt(count, 10);
                        } else if (typeof count === 'number') {
                            this.totalCount = count;
                        } else {
                            return;
                        }

                        await this.goPaging(1);
                    })
                    .catch(err => {
                        console.error(err);
                        this.pagingLoading = false;
                    });
            },
        },
    }
</script>
